<template>
    <div class="error-msg-wrap">
        <div class="error-msg ep-save">
            <h3>Save as v{{ saveVersion }}</h3>
            <label class="ep-lbl" for="ep-status">Status</label>
            <select id="ep-status" v-model="statusModel">
                <option value="Draft">Draft</option>
                <option value="Inactive">Inactive</option>
                <option value="Needs Approval">Needs Approval</option>
                <option value="">Published/Approved</option>
            </select>
            <!-- No small-fix choice on the first save (v0 → v1): there's no signed version to keep.
                 Only a Published/Approved save can ask for new signatures; any other status is always a small fix -->
            <template v-if="version && !status">
                <label class="ep-lbl">Did this change how the work is done?</label>
                <label :class="['ep-opt', { on: !minorChange }]">
                    <input v-model="minorChange" type="radio" :value="false" />
                    <span>
                        <b>Yes, people need to sign again</b>
                        <small>All {{ requiredCount }} assigned {{ requiredCount == 1 ? 'person is' : 'people are' }} asked to sign v{{ version + 1 }}<template v-if="signedCount">, including the {{ signedCount }} who already signed v{{ version }}</template>.</small>
                    </span>
                </label>
                <label :class="['ep-opt', { on: minorChange }]">
                    <input v-model="minorChange" type="radio" :value="true" />
                    <span>
                        <b>No, it's a small fix</b>
                        <small>Typos, wording, or formatting. Stays v{{ version }}, and anyone who signed it stays signed.</small>
                    </span>
                </label>
            </template>
            <label class="ep-lbl" for="ep-note">What changed <span>(optional, shows in History)</span></label>
            <input id="ep-note" v-model="changeNote" type="text" maxlength="500" :placeholder="notePlaceholder" @keydown.enter.prevent="save()" />
            <div class="ep-save-btns">
                <button type="button" class="btn-light" @click="$emit('cancel')">Keep editing</button>
                <button type="button" :class="busy ? 'btn disable-button' : 'btn'" @click="save()">Save v{{ saveVersion }}</button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'EditorSaveDialog',
    // status: v-model for node.NeedsApprovalType (null = Published/Approved)
    props: [ 'status', 'version', 'requiredCount', 'signedCount', 'busy', 'notePlaceholder' ],
    // save: { minorChange, changeNote }. A small fix keeps the version number and LastModified,
    // so current sign-offs stay current
    emits: [ 'update:status', 'cancel', 'save' ],
    data() {
        return {
            minorChange: false,
            changeNote: ''
        }
    },
    computed: {
        // '' stands in for null (Published/Approved) inside the select
        statusModel: {
            get(): string {
                return this.status || '';
            },
            set(value: string) {
                this.$emit('update:status', value || null);
            }
        },
        isMinor(): boolean {
            return !!this.version && (!!this.status || this.minorChange);
        },
        saveVersion(): number {
            return this.isMinor ? this.version : (this.version || 0) + 1;
        }
    },
    methods: {
        save() {
            this.$emit('save', { minorChange: this.isMinor, changeNote: this.changeNote });
        }
    }
});
</script>
